module.exports = __webpack_public_path__ + "fonts/poppins-v21-latin-700.woff2";